import fetch from 'isomorphic-fetch'

const API_URL_AVT = process.env.REACT_APP_AVT_API_URL

const createRequestBody = (requestObj, fromData) => {
  return {
    method: requestObj.method,
    headers: requestObj.headers || {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    body: fromData ? requestObj.body : JSON.stringify(requestObj.body)
  }
}

const getFlagCategoriesByGroup = async () => {
  const requestUrl = `${API_URL_AVT}/odin/api/flag-categories-by-group`

  let requestBody = createRequestBody({
    method: 'GET'
  })
  return fetch(requestUrl, requestBody)
}

/**
 * Update the user password.
 * @param {number} id
 * @param {object} fieldsToUpdate object as { currentPassword, newPassword }
 */
const userChangePassword = async (id, fieldsToUpdate) => {
  const requestUrl = `${API_URL_AVT}/odin/api/users/change-password/${id}`

  const requestBody = createRequestBody({
    method: 'PATCH',
    body: fieldsToUpdate
  })
  return fetch(requestUrl, requestBody)
}

const getClients = async () => {
  const requestUrl = `${API_URL_AVT}/odin/api/clients`

  const requestBody = createRequestBody({
    method: 'GET'
  })
  return fetch(requestUrl, requestBody)
}

const uploadFile = async (body) => {
  const requestUrl = `${API_URL_AVT}/odin/api/uploadFile`

  const headers = {}
  let requestBody = createRequestBody(
    {
      method: 'POST',
      headers,
      body
    },
    true
  )
  return fetch(requestUrl, requestBody)
}

export { userChangePassword, uploadFile, getClients, getFlagCategoriesByGroup }
